import React from "react";
import { connect } from "react-redux";


// import moment from "moment";
import campaignResultDefaultImg from '../../../assets/images/campaignResult-default.png'
import './sheetLogResult.css'
import LeftArrowImg from '../../../assets/images/left-arrow.png'
import RightArrowImg from '../../../assets/images/right-arrow.png'


export class SheetLogResult extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1

        }

    }


    getSheetLogData = () => {

        let sortedArray = this.props.sheetLogs.slice(25 * this.state.currentPage - 25, 25 * this.state.currentPage)
        let JSX = [];

        sortedArray.forEach((entry) => {
            JSX.push(<tr className="SheetLogResult-value" key={entry.id}>
                <td className="SheetLogResult-date-value">{entry.InsertedOn.split('.')[0].replace('T', ' ')}</td>

                <td className="SheetLogResult-campaign-value">{entry.CampaignID}</td>

                <td className="SheetLogResult-spreadsheet-value"><a href={`https://www.gmass.co/gmass/GetRawDataFromSheetV4?emailaddress=${this.props.searchTerm.trim()}&spreadsheetid=${entry.Spreadsheet}&v4worksheetid=${entry.WorksheetIDV4}`} target="_blank" rel="noopener noreferrer">
                    {`${entry.SpreadsheetName} --> ${entry.WorksheetName}`}
                </a></td>

                <td className="SheetLogResult-columns-value">{`${entry.Columns}`}</td>
                <td className="SheetLogResult-conditions-value">{`Duplicates: ${entry.KeepDuplicates} | AndOr: ${entry.AndOr === 'a' ? 'AND' : 'OR'} | Update: ${parseInt(entry.UpdateSheet) ? 'true' : 'false'} |${' '} 
                Filter: ${entry.FilterCriteria}`}</td>
                <td className="SheetLogResult-aliasaddress-value">{entry.AliasAddress}</td>
            </tr>)
        })

        return JSX;

    }

    moveNextPage = () => {
        if (this.state.currentPage < this.props.maxPage) {
            this.setState({ currentPage: this.state.currentPage + 1 })
        }
    }
    movePreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 })
        }
    }

    conditionalRendering = () => {
        if (this.props.sheetLogs) {
            return (<div className="SheetLogResult">

                <div className="SheetLogResult-log-details-container">
                    <table className="SheetLogResult-log-details">
                        <thead>
                            <tr>
                                <th className="SheetLogResult-date">Date</th>
                                <th className="SheetLogResult-campaign">Campaign</th>
                                <th className="SheetLogResult-spreadsheet">Spreadsheet</th>
                                <th className="SheetLogResult-columns">Columns</th>
                                <th className="SheetLogResult-conditions">Conditions</th>
                                <th className="SheetLogResult-aliasaddress">AliasAddress</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getSheetLogData(this.state.currentPage)}
                        </tbody>
                    </table>
                </div>
                <div className="SheetLogResult-pagination">
                    <div className="SheetLogResult-pagination-count">{this.state.currentPage} of {this.props.maxPage}</div>

                    <div className="SheetLogResult-pagination-buttongroup">
                        <button className="SheetLogResult-pagination-button-previous" onClick={this.movePreviousPage}>
                            <img src={LeftArrowImg} alt="Previous" ></img>
                        </button>
                        <button className="SheetLogResult-pagination-button-next" onClick={this.moveNextPage}>
                            <img src={RightArrowImg} alt="Next" ></img>
                        </button>
                    </div>
                </div>

            </div>)
        } else {
            return (<div className="CampaignResult-default">
                <img src={campaignResultDefaultImg} alt="Default" />
                <div> Let The Search Begin!</div>
            </div>)
        }
    }



    render() {
        return (
            <React.Fragment>
                {this.conditionalRendering()}
            </React.Fragment>

        )
    }
}

const mapStateToProps = (state) => {
    if (state.logs.sheetLogs.logs && state.logs.sheetLogs.logs.length) {
        //showing 25 entries max per page
        return { searchTerm: state.logs.sheetLogs.searchTerm, sheetLogs: state.logs.sheetLogs.logs, maxPage: state.logs.sheetLogs.logs.length % 25 === 0 ? state.logs.sheetLogs.logs.length / 25 : Math.ceil(state.logs.sheetLogs.logs.length / 25) };
    } else {
        return { sheetLogs: null, maxPage: 1 }
    }
};

export default connect(mapStateToProps)(SheetLogResult);
